import React, { useEffect, useState } from 'react';
import styles from './Footer.module.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [footerSiteName, setFooterSiteName] = useState('');
  const [footerBuildCredit, setFooterBuildCredit] = useState('');

  useEffect(() => {
      fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_footer?slug=site-name')
        .then(response => response.json())
        .then(data => {
          if (data[0]?.content?.rendered) {
            setFooterSiteName(data[0].content.rendered);
          }
        })
        .catch(error => console.error('Error fetching showcase left content:', error));

      fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_footer?slug=build-credit')
        .then(response => response.json())
        .then(data => {
          if (data[0]?.content?.rendered) {
            setFooterBuildCredit(data[0].content.rendered);
          }
        })
        .catch(error => console.error('Error fetching showcase left content:', error));
    });

  return (
    <footer><span>© {currentYear} <span dangerouslySetInnerHTML={{ __html: footerSiteName }}></span></span><span className={styles.sep}> &bull; </span><span><span dangerouslySetInnerHTML={{ __html: footerBuildCredit }}></span></span></footer>
  );
}

export default Footer;
